import styled from 'styled-components';

const DescriptionStyle = styled.div`
	--infoMarginT: var(--sp13x);
	--infoPadTB: var(--sp7x);
	--infoPadLR: var(--sp5x);
	--descMarginT: var(--sp4x);
	--distanceBorder: var(--sp4x);
	--borderRadius: var(--sp3x);

	background-color: var(--green100);
	border-radius: var(--borderRadius);
	padding: var(--infoPadTB) var(--infoPadLR);
	margin-top: var(--infoMarginT);

	.editor-wrapper {
		margin-top: var(--descMarginT);
	}

	.line {
		margin: var(--distanceBorder) 0;
		border: 1px solid var(--green1000);
		opacity: 0.2;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--infoMarginT: var(--sp10x);
		--descMarginT: var(--sp3x);
		--infoPadTB: var(--sp6x);
		--infoPadLR: var(--sp4x);
		--distanceBorder: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--infoMarginT: var(--sp8x);
		--descMarginT: var(--sp2-5x);
		--infoPadTB: var(--sp5x);
		--infoPadLR: var(--sp3x);
		--borderRadius: var(--sp2-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--infoMarginT: var(--sp7x);
		--descMarginT: var(--sp2x);
		--infoPadTB: var(--sp4x);
		--infoPadLR: var(--sp2-5x);
		--borderRadius: var(--sp2x);
		--distanceBorder: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--infoMarginT: var(--sp6x);
		--infoPadTB: var(--sp3x);
		--infoPadLR: var(--sp2x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--infoMarginT: var(--sp17x);
		--infoPadTB: var(--sp2x);
		--infoPadLR: var(--sp1-5x);
		--distanceBorder: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--infoMarginT: var(--sp5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--infoMarginT: var(--sp3x);
	}
`;

export default DescriptionStyle;
